import { Box, useStyleConfig } from "@chakra-ui/react";
import { useRef } from "react";
import { useScrollEdgeShadow } from "hooks/useScrollStyles";

function MainPanel(props) {
  const { variant, children, ...rest } = props;
  const styles = useStyleConfig("MainPanel", { variant });
  const scrollRef = useRef(null);
  const contentRef = useRef(null);
  // Este Box ES el contenedor con scroll de toda la app (overflow:auto viene
  // del theme, ver src/theme/additions/layout/MainPanel.js) — una sombra acá
  // cubre cualquier pantalla del sistema sin tener que tocar cada vista.
  // Ver useScrollEdgeShadow para el porqué (limitación de macOS/Safari con
  // la barra de scroll nativa, no forzable por CSS).
  const { hasMoreBelow } = useScrollEdgeShadow(scrollRef, contentRef);

  return (
    <Box __css={styles} ref={scrollRef} position="relative" {...rest}>
      <Box ref={contentRef}>{children}</Box>
      {/* sticky + margin-top negativo: se "pega" al borde inferior visible
          sin sumar altura de scroll extra. pointerEvents=none para no
          interceptar clicks/drag del contenido de abajo. */}
      <Box
        position="sticky"
        bottom="0"
        left="0"
        right="0"
        height="28px"
        mt="-28px"
        pointerEvents="none"
        zIndex={4}
        opacity={hasMoreBelow ? 1 : 0}
        transition="opacity .15s ease"
        bgGradient="linear(to-t, rgba(35,30,26,.14), rgba(35,30,26,0))"
      />
    </Box>
  );
}

export default MainPanel;
